<template>
  <div class="application-tracker quick-action-toolbar">
    <div :class="{ 'show-on-hover': onHover }" v-if="isApplicant">
      <v-toolbar flat dense :color="color || ''">
        <v-toolbar-items v-if="candidate.status !== 'Unsuccessful'">
          <v-menu v-model="regretting" max-width="200" top>
            <v-btn slot="activator" color="error">
              <v-icon>mdi-account-off</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                You are about to <strong>Regret</strong> {{ candidate.profile.firstName }}
                {{ candidate.profile.lastName }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="regretting = false">Cancel</v-btn>
                <v-btn @click="regret">Regret</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-toolbar-items>

        <v-spacer />

        <v-toolbar-items>
          <v-menu top left :close-on-content-click="false" max-width="300">
            <v-btn flat slot="activator"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            <ApplicationEventsList :applications="candidate" @done="$emit('done', $event)" />
          </v-menu>
          <v-menu v-if="isApplicant && nextPhase" v-model="advancing" top left max-width="200">
            <v-btn slot="activator" dark flat block color="success">
              <v-icon>mdi-forward</v-icon>
            </v-btn>

            <v-card>
              <v-card-text>
                You are about to advance {{ candidate.profile.firstName }}
                {{ candidate.profile.lastName }} to <strong>{{ nextPhase.name }}</strong>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="advancing = false">Cancel</v-btn>
                <v-btn @click="advance">Advance</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </div>

    <div
      :class="{ 'show-on-hover': onHover }"
      v-else-if="!candidate.invite"
      key="eligibility-toolbar"
    >
      <v-toolbar flat dense color="transparent">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <can I="create" a="Invite">
            <v-menu
              v-if="candidate.status !== 'Unsuccessful'"
              v-model="advancing"
              left
              top
              max-width="200"
            >
              <v-btn slot="activator" dark flat block color="success">
                Invite <v-icon right>mdi-email</v-icon>
              </v-btn>

              <v-card dark>
                <v-card-text>
                  You are about to invite {{ candidate.profile.firstName }}
                  to apply for this opportunity.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="advancing = false">Cancel</v-btn>
                  <v-btn @click="invite">Invite</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </can>
        </v-toolbar-items>
      </v-toolbar>
    </div>
  </div>
</template>

<script>
import ApplicationEventsList from '@/components/applications_tracker/applications/ApplicationEventsList'

export default {
  props: {
    candidate: Object,
    onHover: { type: Boolean, default: false },
    color: { type: String },
  },

  components: { ApplicationEventsList },

  data() {
    return {
      regretting: false,
      advancing: false,
    }
  },
  computed: {
    isApplicant() {
      return this.candidate.createdAt
    },

    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },

    orderedPhases() {
      return this.$store.getters['admin/opportunities/orderedPhases']
    },

    nextPhase() {
      const current = this.orderedPhases.indexOf(
        this.orderedPhases.find(p => p.name === this.candidate.status)
      )
      if (current >= 0 && this.orderedPhases[current + 1]) return this.orderedPhases[current + 1]
      return null
    },
  },
  methods: {
    async advance() {
      if (this.isApplicant && this.advancing) {
        this.hide = true
        await this.$store
          .dispatch('admin/applications/move', {
            applications: this.candidate,
            phase: this.nextPhase,
          })
          .then(
            () => this.$store.dispatch('snackbarSuccess', 'Advanced successfully'),
            () => this.$store.dispatch('snackbarError', 'No application was moved')
          )
        await this.$store.dispatch('admin/applications/fetch', this.candidate.id)
        this.advancing = false
        this.$emit('done', this.newPhase)
        // Reorganise page and counts after changes
        return this.$store.dispatch('admin/applications/updateFilters', {})
      }
    },

    async regret() {
      if (this.isApplicant && this.regretting) {
        await this.$store
          .dispatch('admin/applications/regret', { applications: this.candidate })
          .then(
            data => this.$store.dispatch('snackbarSuccess', 'Regretted'),
            errors => this.$store.dispatch('snackbarError', 'Error: No change was made')
          )
        await this.$store.dispatch('admin/applications/fetch', this.candidate.id)
        // Reorganise page and counts after changes
        await this.$store.dispatch('admin/applications/updateFilters', {})
        this.$emit('done')
        this.regretting = false
      }
    },

    invite() {
      this.$store.dispatch('admin/eligibilities/invite', this.candidate.id).then(async () => {
        this.$emit('done')
        this.$store.dispatch('snackbarSuccess', `Sending Invite(s)`)
        await this.$store.commit('admin/eligibilities/remove', this.candidate.id)
        await this.$store.dispatch('admin/eligibilities/fetch', this.candidate.id)
        // Reorganise page and counts after changes
        return this.$store.dispatch('admin/eligibilities/updateFilters', {})
      })
    },
  },
}
</script>

<style>
.application-tracker.quick-action-toolbar {
  width: 100%;
}
.application-tracker.quick-action-toolbar nav div.v-toolbar__content {
  padding: 0;
  margin-top: -48px;
}

.application-tracker.quick-action-toolbar:hover div.show-on-hover {
  opacity: 1;
}

.application-tracker.quick-action-toolbar div.show-on-hover {
  position: absolute;
  width: 100%;
  opacity: 0;
}
</style>
